import { createEntityStore, type EntityState, type EntityStore, type MultiActiveState } from '@datorama/akita';
import { type TaxonomyObjective } from 'types/models';

export interface TaxonomyObjectiveUI {
   isExpanded: boolean;
}

const defaults: (_entity?: TaxonomyObjective) => TaxonomyObjectiveUI = () => ({ isExpanded: false });

export interface TaxonomyObjectivesState extends EntityState<TaxonomyObjective>, MultiActiveState {}

const store: EntityStore<TaxonomyObjectivesState> = createEntityStore({}, { resettable: true, name: 'taxonomy/objectives' });
store.createUIStore().setInitialEntityState(defaults);

export default store;
